var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"mobile-input",attrs:{"value":_vm.displayValue,"rules":_vm.computedRules,"maxlength":"9","prepend-inner":"09","label":"شماره همراه"},on:{"input":_vm.onInput,"keydown":_vm.onKeyDown}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }